module.exports = __webpack_public_path__ + "img/icon4.5cd3e892.svg";